import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import { Button, Grid, useMediaQuery, useTheme } from "@mui/material";
import { Axios } from "../App";

const EventDataImporter = () => {
  const navigate = useNavigate();
  const alert = useAlert();
  const { id } = useParams();
  const [file, setFile] = useState();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  const fileReader = new FileReader();

  const handleOnChange = (e: any) => {
    setFile(e.target.files[0]);
  };

  const handleImport = async (csvDataArray: any[]) => {
    await Axios.post("participants/deleteAllParticipantsDataByEventID.php", {
      id: id,
    })
      .then(({ data }) => {
        if (!data?.success) throw new Error(data?.message);
      })
      .catch((e) => {
        console.error(e);
      });

    await saveToDatabase(csvDataArray);
  };

  const saveToDatabase = async (csvDataArray: any[]) => {
    Axios.post("participants/saveParticipantDataFromCSV.php", {
      id: id,
      name: csvDataArray,
    })
      .then(({ data }) => {
        if (!data?.success) throw new Error(data?.message);
        alert.success("Mentve!");
        setTimeout(() => {
          navigate(`/event-manager/edit/${id}/data`);
        }, 2000);
      })
      .catch((e) => {
        console.error(e);
        alert.error(
          "Server error! Lehet nem minden név került importálásra. Kérlek, próbáld újra."
        );
        setTimeout(() => {
          navigate(`/event-manager/edit/${id}/data`);
        }, 1000);
      });
  };

  const handleOnSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (!file) {
      alert.error("Nincs kiválasztott file.");
      return;
    }

    // @ts-ignore
    let extension = file.name.split(".").pop().toLowerCase();

    if (extension === "xls" || extension === "xlsx") {
      fileReader.onload = (evt) => {
        // @ts-ignore
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        // @ts-ignore
        const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
        const csv = Papa.parse(data, {
          header: false,
        });
        const parsedData = csv?.data;
        handleImport(parsedData);
      };
      fileReader.readAsBinaryString(file);
    }

    if (extension === "csv") {
      fileReader.onload = async ({ target }) => {
        // @ts-ignore
        const csv = Papa.parse(target.result, {
          header: false,
        });
        // @ts-ignore
        const parsedData = csv?.data;
        handleImport(parsedData);
      };

      fileReader.readAsText(file);
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <form
            style={{
              display: !matches ? "flex" : "block",
              alignItems: "center",
            }}
          >
            <input
              type={"file"}
              id={"csvFileInput"}
              accept={".csv, .xls, .xlsx"}
              onChange={handleOnChange}
              style={{
                marginBottom: matches ? "16px" : "0",
              }}
            />
            <Button
              variant="contained"
              color="primary"
              disabled={!file}
              fullWidth={matches}
              onClick={(e) => {
                handleOnSubmit(e);
              }}
            >
              IMPORT CSV
            </Button>
          </form>
        </Grid>
      </Grid>
    </>
  );
};

export default React.memo(EventDataImporter);
